import { Toaster as SonnerToaster } from 'sonner';

import { useTheme } from '@/lib/hooks';

// Wrapped Sonner Toaster — theme-aware, Moveris-styled.
// Mount once in App.tsx via <Toaster />.
// Use notify.* utilities to trigger toasts — never import sonner directly.
export function Toaster() {
  const { resolvedTheme } = useTheme();

  return (
    <SonnerToaster
      theme={resolvedTheme}
      position="bottom-right"
      closeButton
      toastOptions={{
        style: { fontFamily: 'var(--font-sans)' },
      }}
    />
  );
}
